<template>
  <app-dialog
    v-model="model"
    :close-button="false"
    :subtitle="subtitle"
    :title="title"
    :width="470"
    @submit="close({ confirmed: true })"
  >
    <template #footer>
      <div class="flex justify-end gap-4">
        <app-button
          v-bind="{
            color: 'dark',
            variant: 'tonal',
            ...cancelButtonProps,
          }"
          @click="close()"
        >
          {{ cancelButtonProps?.label ?? $t("app.cta.cancel") }}
        </app-button>

        <app-button
          v-bind="{
            color: 'danger',
            type: 'submit',
            ...confirmButtonProps,
          }"
        >
          {{ confirmButtonProps?.label ?? $t("app.cta.confirm") }}
        </app-button>
      </div>
    </template>
  </app-dialog>
</template>

<script lang="ts" setup>
import type { TranslateResult } from "vue-i18n";

import type { ButtonProps } from "../../button/button.model";

const model = defineModel<boolean>({ default: false });

defineProps<{
  title: TranslateResult;
  subtitle?: TranslateResult;
  confirmButtonProps?: ButtonProps & { label?: TranslateResult };
  cancelButtonProps?: ButtonProps & { label?: TranslateResult };
}>();

const { close } = useDialog("ConfirmationDialog");
</script>
